import React from 'react';
import PropTypes from 'prop-types';

import useGetUtmParams from '../../../hooks/useGetUtmParams';
import { useResponsiveEffect } from '../../../hooks';
import Footer from './Footer';

const FooterContainer = ({ canShowSubscriptionFeatures }) => {
  const { desktop } = useResponsiveEffect();
  const utmParams = useGetUtmParams();
  return !desktop ? null : (
    <Footer
      canShowSubscriptionFeatures={canShowSubscriptionFeatures}
      utmParams={utmParams}
    />
  );
};

FooterContainer.propTypes = {
  canShowSubscriptionFeatures: PropTypes.bool.isRequired,
};

export default FooterContainer;
